// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22efL","newExpiryDate":"styles_newExpiryDate__2EE9H","footer":"styles_footer__3UouY"};